export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/ibm.98cbb3c8.svg","height":69,"width":141,"blurWidth":0,"blurHeight":0};